
import { Twitter, Facebook, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-primary text-white py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {/* Legal Section */}
          <div>
            <h3 className="font-semibold text-lg mb-3">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/privacy-policy" 
                  className="hover:text-gray-300 transition-colors"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Privacy Notice
                </Link>
              </li>
              <li>
                <a 
                  href="/documents/SPO-Rules-2022-.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-gray-300 transition-colors"
                >
                  Membership Terms
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="lg:col-span-2">
            <h3 className="font-semibold text-lg mb-3">Contact</h3>
            <address className="not-italic">
              <p>Seed Potato Organisation Ltd.</p>
              <p>Azets, 5 Whitefriars Crescent</p>
              <p>Perth PH2 0PA</p>
            </address>
          </div>

          {/* Social Section */}
          <div>
            <h3 className="font-semibold text-lg mb-3">Follow Us</h3>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/SeedPotatoOrganisation" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-gray-300 transition-colors" 
                aria-label="Follow us on Facebook"
              >
                <Facebook size={24} />
              </a>
              <a 
                href="http://x.com/s_potato_org" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-gray-300 transition-colors" 
                aria-label="Follow us on X (formerly Twitter)"
              >
                <Twitter size={24} />
              </a>
              <a 
                href="https://www.linkedin.com/company/seed-potato-organisation/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-gray-300 transition-colors" 
                aria-label="Follow us on LinkedIn"
              >
                <Linkedin size={24} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright Notice */}
        <div className="mt-6 pt-6 border-t border-white/20 text-center">
          <p>© 2025 Seed Potato Organisation. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
